/**
 * Ventana móvil de 24hs usada para decidir si un agendamiento "Requiere coordinación"
 * (no se puede automatizar del todo — hay que coordinar con CX). Se evalúa por horario
 * exacto (ahora + 24hs), nunca por si la fecha cae en el día calendario siguiente.
 * Ej: si son las 10:00 de hoy, una sesión mañana a las 23:00 tiene 34hs reales de
 * anticipación y NO debe marcarse, aunque "mañana" sea el día calendario siguiente.
 *
 * Compartido por CalendarCell.tsx (preview al pasar el mouse / seleccionar el horario
 * en la grilla) y BookSessionModal.tsx (revalidación al confirmar el agendamiento),
 * para que ambos chequeos usen exactamente el mismo criterio.
 */
export function needsCoordination(targetDateTime: Date, now: Date = new Date()): boolean {
  const in24h = new Date(now.getTime() + 24 * 60 * 60 * 1000);
  return targetDateTime > now && targetDateTime < in24h;
}
